(function () {
  const root = document.querySelector('.clpdp-quote[data-quote-endpoint]');
  if (!root) return;

  const toggle = root.querySelector('.clpdp-quote__toggle');
  const panel = root.querySelector('.clpdp-quote__panel');
  const input = root.querySelector('.clpdp-quote__form input');
  const submit = root.querySelector('.clpdp-quote__submit');
  const status = root.querySelector('.clpdp-quote__status');
  const results = root.querySelector('.clpdp-quote__results');
  const productForm = root.closest('form');
  const priceLinks = [...document.querySelectorAll('[data-clikea-shipping-at-price]')];
  function priceCopy(text,quoted=false) {priceLinks.forEach(link=>{link.querySelector('[data-clikea-shipping-at-price-text]').textContent=text;link.dataset.quoted=String(quoted);});}
  priceLinks.forEach(link=>link.addEventListener('click',()=>{toggle.click();}));
  const deliveryTitle = root.querySelector('[data-clpdp-delivery-title]');
  const deliveryDetail = root.querySelector('[data-clpdp-delivery-detail]');
  const deliveryCost = root.querySelector('[data-clpdp-delivery-cost]');
  const deliveryCutoff = root.querySelector('[data-clpdp-delivery-cutoff]');
  const deliveryAlternative = root.querySelector('[data-clpdp-delivery-alternative]');
  const chooseOptions = productForm?.closest('.js-product')?.querySelector('button[x-show="!all_options_selected"]');
  if (!toggle || !panel || !input || !submit || !status || !results || !productForm) return;
  // Keep shipping controls out of the add-to-cart form and the product layout.
  document.body.append(panel);
  const preferenceKey = 'clikea.product.shipping.preference.v1';
  const transferKey = 'clikea.product.shipping.service.v1';
  let currentRateKey = '';
  let rememberedPreference = null;
  let savedPostalCode = '';
  try {
    const saved = JSON.parse(localStorage.getItem('clikea.shipping.destination.v1') || 'null');
    if (/^\d{5}$/.test(saved?.postalCode || '')) {
      input.value = saved.postalCode;
      savedPostalCode = saved.postalCode;
    }
  } catch { /* The quote remains usable without local storage. */ }

  let request = null;
  let requestSignature = '';
  let productChangeTimer = null;
  let sequence = 0;
  let dispatchTimer = null;
  let displayedQuote = null;
  let displayedBucket = '';
  let failureCooldownUntil = 0;
  const cacheStorageKey = 'clikea.shipping.quotes.v1';
  const cacheLifetimeMs = 5 * 60 * 1000;
  const money = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
  const dateFormat = new Intl.DateTimeFormat('es-MX', {
    weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
  });
  const mexicoClockFormat = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });

  function mexicoClock() {
    const parts = mexicoClockFormat.formatToParts(new Date());
    const part = (type) => parts.find((item) => item.type === type)?.value || '';
    return {
      year: Number(part('year')),
      month: Number(part('month')),
      day: Number(part('day')),
      date: `${part('year')}-${part('month')}-${part('day')}`,
      hour: Number(part('hour')),
      minute: Number(part('minute')),
      second: Number(part('second'))
    };
  }

  function cutoffBucket(clock = mexicoClock()) {
    return `${clock.date}:${clock.hour < 15 ? 'before' : 'after'}`;
  }

  function readCachedQuote(signature) {
    try {
      const cache = JSON.parse(localStorage.getItem(cacheStorageKey) || '{}');
      const entry = cache[`${cutoffBucket()}:${signature}`];
      return entry?.expiresAt > Date.now() && Array.isArray(entry.quote?.rates) ? entry.quote : null;
    } catch { return null; }
  }

  function storeCachedQuote(signature, quote) {
    try {
      const now = Date.now();
      const cache = JSON.parse(localStorage.getItem(cacheStorageKey) || '{}');
      const fresh = Object.fromEntries(Object.entries(cache).filter(([, entry]) => entry?.expiresAt > now).slice(-29));
      fresh[`${cutoffBucket()}:${signature}`] = { quote, expiresAt: now + cacheLifetimeMs };
      localStorage.setItem(cacheStorageKey, JSON.stringify(fresh));
    } catch { /* The estimator still works when storage is unavailable. */ }
  }

  function dateLabel(value) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const date = new Date(value + 'T12:00:00Z');
    return Number.isNaN(date.getTime()) ? null : dateFormat.format(date);
  }

  function make(tag, className, content) {
    const element = document.createElement(tag);
    element.className = className;
    if (content != null) element.textContent = content;
    return element;
  }

  function clearDisplayedQuote() {
    priceCopy(/^\d{5}$/.test(input.value.trim()) ? 'Envío por confirmar · Ver opciones' : 'Consulta costo y entrega');
    if (dispatchTimer) window.clearTimeout(dispatchTimer);
    dispatchTimer = null;
    displayedQuote = null;
    displayedBucket = '';
    currentRateKey = '';
  }

  function needsVariantSelection() {
    return !!chooseOptions && getComputedStyle(chooseOptions).display !== 'none';
  }

  function clearPendingRequest() {
    if (request) request.abort();
    if (request) sequence += 1;
    request = null;
    requestSignature = '';
    submit.disabled = false;
  }

  function showVariantRequired() {
    clearPendingRequest();
    clearDisplayedQuote();
    results.hidden = true;
    status.textContent = 'Selecciona la presentación para calcular el envío.';
    root.classList.remove('is-quoted');
    if (deliveryTitle) deliveryTitle.textContent = 'Elige una presentación';
    if (deliveryDetail) deliveryDetail.textContent = 'Después verás fecha y costo para tu código postal.';
    if (deliveryCost) deliveryCost.hidden = true;
    if (deliveryCutoff) deliveryCutoff.hidden = true;
    if (deliveryAlternative) deliveryAlternative.hidden = true;
  }

  function dispatchCopy(quote, clock) {
    const secondsNow = clock.hour * 3600 + clock.minute * 60 + clock.second;
    const secondsToMidnight = 86400 - secondsNow;
    const tomorrow = new Date(Date.UTC(clock.year, clock.month - 1, clock.day + 1)).toISOString().slice(0, 10);
    if (quote.dispatchToday && quote.dispatchDate === clock.date) {
      const secondsToCutoff = 15 * 3600 - secondsNow;
      if (secondsToCutoff <= 0) {
        return { text: 'Confirmando el próximo despacho…', refreshNow: true, nextSeconds: 1 };
      }
      if (secondsToCutoff <= 600) {
        const minutes = Math.ceil(secondsToCutoff / 60);
        return {
          text: `Se envía hoy si compras en los próximos ${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}.`,
          minutes,
          nextSeconds: Math.min(secondsToMidnight, 60 - clock.second)
        };
      }
      return {
        text: 'Se envía hoy si compras antes de las 3:00 p. m.',
        nextSeconds: Math.min(secondsToMidnight, secondsToCutoff - 600)
      };
    }
    if (quote.dispatchDate === tomorrow) return { text: 'Se envía mañana.', nextSeconds: secondsToMidnight };
    const label = dateLabel(quote.dispatchDate);
    return { text: label ? `Se envía el ${label}.` : 'Fecha de despacho por confirmar.', nextSeconds: secondsToMidnight };
  }

  function updateDispatchCopy(quote) {
    if (dispatchTimer) window.clearTimeout(dispatchTimer);
    dispatchTimer = null;
    const clock = mexicoClock();
    const copy = dispatchCopy(quote, clock);
    const destination = results.querySelector('.clpdp-quote__destination');
    if (destination) destination.textContent = `${quote.destination} · ${copy.text}`;
    if (deliveryCutoff) {
      if (copy.minutes != null) {
        deliveryCutoff.replaceChildren(
          document.createTextNode('Se envía hoy si compras en los próximos '),
          make('strong', 'clpdp-delivery__minutes', `${copy.minutes} ${copy.minutes === 1 ? 'minuto' : 'minutos'}`),
          document.createTextNode('.')
        );
      } else {
        deliveryCutoff.textContent = copy.text;
      }
      deliveryCutoff.hidden = false;
    }
    displayedQuote = quote;
    displayedBucket = cutoffBucket(clock);
    if (document.visibilityState === 'hidden') return;
    dispatchTimer = window.setTimeout(() => {
      dispatchTimer = null;
      if (document.visibilityState !== 'visible') return;
      if (copy.refreshNow || cutoffBucket() !== displayedBucket) quoteDelivery();
      else updateDispatchCopy(quote);
    }, Math.max(1000, copy.nextSeconds * 1000 + 150));
  }

  function currentVariant() {
    const selected = productForm.querySelector('[name="id"]');
    const urlVariant = new URLSearchParams(window.location.search).get('variant');
    return Number(selected && selected.value || urlVariant || root.dataset.defaultVariant);
  }

  function currentQuantity() {
    const field = productForm.querySelector('[name="quantity"]');
    return Number(field && field.value || 1);
  }

  function productPreferenceKey(quote) {
    return `${currentVariant()}:${currentQuantity()}:${quote.postalCode}`;
  }

  function selectProductRate(quote, rate, remember = false) {
    if (!rate) return;
    currentRateKey = `${rate.service}|${rate.amount}`;
    results.querySelectorAll('[data-clpdp-shipping-rate]').forEach(choice => {
      choice.checked = choice.dataset.clpdpShippingRate === currentRateKey;
    });
    const arrival = dateLabel(rate.estimatedDeliveryDate);
    if (deliveryTitle) deliveryTitle.textContent = arrival ? `Llega el ${arrival}` : 'Opciones de entrega disponibles';
    if (deliveryDetail) deliveryDetail.textContent = `${arrival ? 'Fecha estimada' : 'Costo calculado; fecha por confirmar al pagar'} · ${quote.destination} · ${rate.service}`;
    if (deliveryCost) {
      deliveryCost.textContent = rate.amount === 0 ? 'Envío gratis' : money.format(rate.amount);
      deliveryCost.dataset.free = String(rate.amount === 0);
      deliveryCost.hidden = false;
    }
    if (deliveryAlternative) {
      const fastest = quote.rates.filter(r => dateLabel(r.estimatedDeliveryDate)).sort((a,b) => a.estimatedDeliveryDate.localeCompare(b.estimatedDeliveryDate))[0];
      const faster = arrival && fastest && fastest.estimatedDeliveryDate < rate.estimatedDeliveryDate;
      deliveryAlternative.textContent = faster ? `Opción más rápida: ${dateLabel(fastest.estimatedDeliveryDate)} por ${money.format(fastest.amount)}.` : '';
      deliveryAlternative.hidden = !faster;
    }
    priceCopy(`${rate.amount === 0 ? 'Envío gratis' : 'Envío ' + money.format(rate.amount)} · ${arrival ? 'Llega el ' + arrival + ' (estimado)' : 'Fecha por confirmar'} · Ver opciones`,true);
    root.classList.add('is-quoted');
    if (remember) {
      const expiresAt = Date.now() + cacheLifetimeMs;
      rememberedPreference = {key:productPreferenceKey(quote),service:rate.service,expiresAt};
      const preference = {postalCode:quote.postalCode,service:rate.service,variantId:currentVariant(),expiresAt};
      try {
        sessionStorage.setItem(preferenceKey,JSON.stringify(rememberedPreference));
        sessionStorage.setItem(transferKey,JSON.stringify(preference));
      } catch { /* Selection still works when browser storage is unavailable. */ }
      window.dispatchEvent(new CustomEvent('clikea:shipping-service-preferred',{detail:preference}));
    }
  }

  function closeOptions() {
    if (panel.open) panel.close();
  }

  function renderQuote(quote) {
    results.replaceChildren();
    results.append(make('div', 'clpdp-quote__destination', ''));
    quote.rates.forEach((rate) => {
      const row = make('label', 'clpdp-quote__rate');
      const choice = make('input', 'clpdp-shipping-choice');
      choice.type = 'radio';
      choice.name = 'clpdp-shipping-rate-' + panel.id;
      choice.value = rate.service;
      choice.dataset.clpdpShippingRate = `${rate.service}|${rate.amount}`;
      choice.addEventListener('change',() => {
        if (choice.checked && currentRateKey !== choice.dataset.clpdpShippingRate) selectProductRate(quote,rate,true);
      });
      choice.addEventListener('keydown',event => {if (event.key === 'Enter') {event.preventDefault();choice.click();}});
      row.addEventListener('click',event => {
        if (event.target !== choice) event.preventDefault();
        selectProductRate(quote,rate,true);
        closeOptions();
      });
      row.append(choice);
      row.append(make('strong', '', rate.service));
      const price = make('div', 'clpdp-quote__price');
      if (rate.amount === 0 && /estafeta/i.test(rate.service)) {
        const reference = make('span', 'clpdp-quote__reference', 'Referencia ');
        reference.append(make('s', '', money.format(139)));
        price.append(reference);
      }
      price.append(make('b', '', rate.amount === 0 ? 'Gratis' : money.format(rate.amount)));
      row.append(price);
      const arrival = dateLabel(rate.estimatedDeliveryDate);
      row.append(make('small', '', arrival ? 'Entrega estimada: ' + arrival : 'Fecha por confirmar al pagar'));
      results.append(row);
    });
    results.hidden = false;
    let saved = rememberedPreference;
    try { saved = JSON.parse(sessionStorage.getItem(preferenceKey) || 'null') || saved; } catch {}
    const preferred = saved?.expiresAt > Date.now() && saved.key === productPreferenceKey(quote) ? quote.rates.find(r => r.service === saved.service) : null;
    const dated = quote.rates.filter(r => dateLabel(r.estimatedDeliveryDate)).sort((a,b) => a.estimatedDeliveryDate.localeCompare(b.estimatedDeliveryDate) || a.amount-b.amount);
    selectProductRate(quote,preferred || dated.find(r => r.amount === 0) || quote.rates.find(r => r.amount === 0) || dated[0] || quote.rates[0]);
    updateDispatchCopy(quote);
  }

  async function quoteDelivery({ interactive = false } = {}) {
    const postalCode = input.value.trim();
    if (!/^\d{5}$/.test(postalCode)) {
      clearDisplayedQuote();
      status.textContent = 'Ingresa un código postal de cinco dígitos.';
      results.hidden = true;
      root.classList.remove('is-quoted');
      if (deliveryTitle) deliveryTitle.textContent = 'Revisa tu código postal';
      if (deliveryDetail) deliveryDetail.textContent = 'También puedes consultar el envío con tu dirección completa al pagar.';
      if (deliveryCost) deliveryCost.hidden = true;
      if (deliveryCutoff) deliveryCutoff.hidden = true;
      if (deliveryAlternative) deliveryAlternative.hidden = true;
      input.focus();
      return;
    }
    if (needsVariantSelection()) {
      showVariantRequired();
      return;
    }
    const variantId = currentVariant();
    const quantity = currentQuantity();
    if (!Number.isSafeInteger(variantId) || !Number.isInteger(quantity) || quantity < 1 || quantity > 100) {
      clearPendingRequest();
      clearDisplayedQuote();
      status.textContent = 'Selecciona una presentación y una cantidad de 1 a 100 piezas para cotizar. Puedes confirmar el envío al pagar.';
      results.hidden = true;
      root.classList.remove('is-quoted');
      if (deliveryTitle) deliveryTitle.textContent = quantity > 100 ? 'Confirma el envío al pagar' : 'Calcula cuándo te llega';
      if (deliveryDetail) deliveryDetail.textContent = quantity > 100 ? 'Puedes continuar con tu compra y consultar las opciones de envío al pagar.' : 'Selecciona una presentación disponible.';
      if (deliveryCost) deliveryCost.hidden = true;
      if (deliveryCutoff) deliveryCutoff.hidden = true;
      if (deliveryAlternative) deliveryAlternative.hidden = true;
      return;
    }

    const signature = `${variantId}:${quantity}:${postalCode}`;
    if (interactive && matchMedia('(max-width: 639px)').matches) input.blur();
    if (request && requestSignature === signature) return;
    if (request) {
      request.abort();
      sequence += 1;
      request = null;
      requestSignature = '';
      submit.disabled = false;
    }
    const cached = readCachedQuote(signature);
    if (cached) {
      if (needsVariantSelection()) {
        showVariantRequired();
        return;
      }
      status.textContent = '';
      renderQuote(cached);
      window.dispatchEvent(new CustomEvent('clikea:shipping-quoted', { detail: cached }));
      return;
    }
    // A failed automatic quote should not repeatedly interrupt variant browsing.
    // The shopper can still explicitly retry with Calcular at any time.
    if (!interactive && Date.now() < failureCooldownUntil) return;
    clearDisplayedQuote();
    const controller = new AbortController();
    request = controller;
    requestSignature = signature;
    const thisRequest = ++sequence;
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    const retryBefore = Date.now() + 6000;
    const cancelWhenHidden = () => {
      if (document.visibilityState === 'hidden') controller.abort();
    };
    document.addEventListener('visibilitychange', cancelWhenHidden);
    submit.disabled = true;
    status.textContent = interactive ? 'Consultando tarifas y fechas disponibles…' : '';
    root.classList.remove('is-quoted');
    if (deliveryTitle) deliveryTitle.textContent = interactive ? `Calculando entrega a ${postalCode}…` : `Envío a ${postalCode}`;
    if (deliveryDetail) deliveryDetail.textContent = interactive ? 'Buscando fecha y costo para este producto.' : 'La fecha estimada aparecerá aquí.';
    if (deliveryCost) deliveryCost.hidden = true;
    if (deliveryCutoff) deliveryCutoff.hidden = true;
    if (deliveryAlternative) deliveryAlternative.hidden = true;
    results.hidden = true;
    try {
      let response;
      for (let attempt = 0; attempt < 2; attempt++) {
        response = await fetch(root.dataset.quoteEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'omit',
          body: JSON.stringify({ variantId, quantity, postalCode }),
          signal: controller.signal
        });
        // Retry one quick upstream failure, never a validation error or rate limit.
        if (attempt || response.status < 500 || Date.now() >= retryBefore) break;
        await response.body?.cancel();
        await new Promise((resolve,reject) => {
          if (controller.signal.aborted) { reject(new DOMException('Aborted','AbortError')); return; }
          const cancel = () => { clearTimeout(timer); reject(new DOMException('Aborted','AbortError')); };
          const timer = setTimeout(() => {controller.signal.removeEventListener('abort',cancel);resolve();},400);
          controller.signal.addEventListener('abort',cancel,{once:true});
        });
      }
      const payload = await response.json();
      if (thisRequest !== sequence) return;
      if (needsVariantSelection() || currentVariant() !== variantId || currentQuantity() !== quantity || input.value.trim() !== postalCode) {
        if (needsVariantSelection()) showVariantRequired();
        return;
      }
      if (!response.ok || !payload.ok || !Array.isArray(payload.quote && payload.quote.rates)) {
        const error = new Error(payload.error || 'No pudimos confirmar el envío para este código postal.');
        error.status = response.status;
        error.postalInvalid = response.status === 422 && /c[oó]digo postal/i.test(payload.error || '');
        throw error;
      }
      failureCooldownUntil = 0;
      status.textContent = '';
      if (!(payload.quote.dispatchToday && mexicoClock().hour >= 15)) storeCachedQuote(signature, payload.quote);
      renderQuote(payload.quote);
      window.dispatchEvent(new CustomEvent('clikea:shipping-quoted', { detail: payload.quote }));
    } catch (error) {
      if (thisRequest !== sequence) return;
      failureCooldownUntil = Date.now() + 60000;
      status.textContent = error.postalInvalid
        ? 'Revisa tu código postal. El cotizador rápido no pudo validarlo; también puedes revisarlo con tu dirección completa al pagar.'
        : 'No pudimos cotizar ahora. No te preocupes: puedes continuar con tu compra y consultar las opciones de envío al pagar.';
      if (deliveryTitle) deliveryTitle.textContent = 'Envío por confirmar al pagar';
      if (deliveryDetail) deliveryDetail.textContent = 'Puedes seguir comprando. El costo y la fecha se revisan con tu dirección completa en el pago.';
    } finally {
      window.clearTimeout(timeout);
      document.removeEventListener('visibilitychange', cancelWhenHidden);
      if (thisRequest === sequence) {
        submit.disabled = false;
        request = null;
        requestSignature = '';
      }
    }
  }

  toggle.addEventListener('click', () => {
    if (!panel.open) { panel.showModal(); toggle.setAttribute('aria-expanded','true'); input.focus(); }
  });
  panel.querySelectorAll('[data-clpdp-shipping-close]').forEach(button => button.addEventListener('click',closeOptions));
  panel.addEventListener('keydown',event => {if (event.key === 'Escape') {event.preventDefault();event.stopPropagation();closeOptions();}});
  panel.addEventListener('close',() => {toggle.setAttribute('aria-expanded','false');toggle.focus({preventScroll:true});});
  panel.addEventListener('click',event => {
    const box = panel.getBoundingClientRect();
    if (event.target === panel && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) closeOptions();
  });
  input.addEventListener('input',() => {
    clearPendingRequest();clearDisplayedQuote();results.hidden=true;status.textContent='Pulsa Calcular para consultar este código postal.';
    root.classList.remove('is-quoted');
    if (deliveryTitle) deliveryTitle.textContent='Calcula cuándo te llega';
    if (deliveryDetail) deliveryDetail.textContent='Las opciones se actualizan al calcular tu código postal.';
    if (deliveryCost) deliveryCost.hidden=true;
    if (deliveryCutoff) deliveryCutoff.hidden=true;
    if (deliveryAlternative) deliveryAlternative.hidden=true;
  });
  submit.addEventListener('click', () => quoteDelivery({ interactive: true }));
  input.addEventListener('keydown', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      quoteDelivery({ interactive: true });
    }
  });
  window.addEventListener('clikea:shipping-destination-saved', () => {priceCopy('Envío por confirmar · Ver opciones');});
  window.addEventListener('clikea:shipping-cleared', () => {
    rememberedPreference = null;
    try {sessionStorage.removeItem(preferenceKey);sessionStorage.removeItem(transferKey);} catch {}
    failureCooldownUntil = 0;
    clearDisplayedQuote();
    if (request) request.abort();
    sequence += 1;
    request = null;
    requestSignature = '';
    if (productChangeTimer) window.clearTimeout(productChangeTimer);
    submit.disabled = false;
    input.value = '';
    results.hidden = true;
    status.textContent = '';
    root.classList.remove('is-quoted');
    if (deliveryTitle) deliveryTitle.textContent = 'Calcula cuándo te llega';
    if (deliveryDetail) deliveryDetail.textContent = deliveryDetail.dataset.defaultDetail || 'Ingresa tu código postal para ver fecha y costo.';
    if (deliveryCost) deliveryCost.hidden = true;
    if (deliveryCutoff) deliveryCutoff.hidden = true;
    if (deliveryAlternative) deliveryAlternative.hidden = true;
  });
  window.addEventListener('clikea:product-changed', () => {
    priceCopy(/^\d{5}$/.test(input.value.trim()) ? 'Envío por confirmar · Ver opciones' : 'Consulta costo y entrega');
    if (!/^\d{5}$/.test(input.value.trim())) return;
    if (productChangeTimer) window.clearTimeout(productChangeTimer);
    productChangeTimer = window.setTimeout(() => {
      productChangeTimer = null;
      if (document.visibilityState === 'visible') quoteDelivery();
    }, 450);
  });
  if (chooseOptions) {
    new MutationObserver(() => {
      if (needsVariantSelection()) showVariantRequired();
    }).observe(chooseOptions, { attributes: true, attributeFilter: ['style', 'class'] });
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden' && productChangeTimer) {
      window.clearTimeout(productChangeTimer);
      productChangeTimer = null;
    }
    if (document.visibilityState === 'hidden' && dispatchTimer) {
      window.clearTimeout(dispatchTimer);
      dispatchTimer = null;
    }
    if (document.visibilityState === 'visible' && displayedQuote) {
      if (cutoffBucket() !== displayedBucket) quoteDelivery();
      else updateDispatchCopy(displayedQuote);
    }
  });
  if (savedPostalCode) quoteDelivery();
})();
